import { render, staticRenderFns } from "./DiagramBuilder.vue?vue&type=template&id=125cf4dc&scoped=true"
import script from "./DiagramBuilder.vue?vue&type=script&lang=js"
export * from "./DiagramBuilder.vue?vue&type=script&lang=js"
import style0 from "./DiagramBuilder.vue?vue&type=style&index=0&id=125cf4dc&prod&lang=scss&scoped=true"
import style1 from "./DiagramBuilder.vue?vue&type=style&index=1&id=125cf4dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125cf4dc",
  null
  
)

export default component.exports